// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"226049eda2799477","531":"e768545714f0aa7f","804":"77036c8b5df74f9b","901":"9dbff2e13711323a"}[chunkId] + ".css";
};